import styled from 'styled-components';
import { Button } from '~/components';
import { colors } from '~/styles/colors';

export const EnergyConsumptionGoalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
`;

export const EnergyConsumptionRegisterContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    flex-direction: column;
  }
`;

export const RegisterButton = styled(Button)`
  width: 228px;
  height: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const FilterTableContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: start;
    gap: 8px;

    div > label {
      width: auto;
    }
  }
`;

export const EmptyGoalsDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 8px;

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    text-align: center;
  }

  & > div > h3, & > div > p {
    margin: 0;
    font-weight: 400;
    line-height: 180%;
  }

  & > div > h3 {
    font-size: 14px;
    color: ${colors.text['main-900']};
  }

  & > div > p {
    font-size: 12px;
    color: ${colors.text['sub-500']};
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 300px;
`;
